import { Link } from "react-router-dom";

const Insurance = ({ redirectUrl }: { redirectUrl: string }) => {
  if (!redirectUrl) {
    return <></>;
  }
  return (
    <div className="w-full bg-white p-6 rounded-[12px] flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Insurance</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="flex gap-4">
        <div className="w-1/2 bg-[linear-gradient(57deg,#090909_1%,#292929_98%)] text-white p-6 rounded-[10px] relative overflow-hidden">
          <img
            src="/assets/money/rings.webp"
            className="bottom-12 absolute left-[50%] -translate-x-[50%] z-0 pointer-events-none"
          />
          <img
            src="/assets/money/health_insurance.svg"
            className="w-[50px] h-[50px]"
          ></img>
          <h2 className="text-[22px] font-bold">Health Insurance</h2>
          <h4 className="text-[15px] font-normal w-[272px]">
            Covers your medical bills if you’re hospitalised.
          </h4>
          <Link
            to={
              redirectUrl +
              (redirectUrl.includes("?") ? "&type=health" : "?type=health")
            }
          >
            <button className="bg-[#007aff] py-[8px] px-[69px] rounded-[12px] leading-[1.33] mt-[43px]">
              Schedule a Call
            </button>
          </Link>
        </div>
        <div className="w-1/2 bg-[linear-gradient(57deg,#090909_1%,#292929_98%)] text-white p-6 rounded-[10px] relative overflow-hidden">
          <img
            src="/assets/money/rings.webp"
            className="bottom-12 absolute left-[50%] -translate-x-[50%] z-0 pointer-events-none"
          />
          <img
            src="/assets/money/life_insurance.svg"
            className="w-[50px] h-[50px]"
          ></img>
          <h2 className="text-[22px] font-bold">Life Insurance</h2>
          <h4 className="text-[15px] font-normal w-[272px]">
            Your family gets 1 crore or more in the event of your passing.
          </h4>
          <Link
            to={
              redirectUrl +
              (redirectUrl.includes("?") ? "&type=life" : "?type=life")
            }
          >
            <button className="bg-[#007aff] py-[8px] px-[69px] rounded-[12px] leading-[1.33] mt-[43px]">
              Schedule a Call
            </button>
          </Link>
        </div>
      </div>
      <div className="flex items-center gap-4 border-[1px] border-[#d7d7d7] rounded-[10px] p-6 justify-between relative overflow-hidden">
        <img
          src="/assets/money/topology-design.webp"
          className="w-[262px] text-[#090909] absolute left-[55%] top-[20px] z-0 pointer-events-none"
        />
        <div className="flex items-center w-1/2 gap-4">
          <img
            src="/assets/money/review.svg"
            className="w-[50px] h-[50px] text-[#090909]"
          ></img>
          <div className="">
            <h2 className="font-bold text-[22px]">Review My Policy</h2>
            <h4>
              Already have insurance? Let’s analyze your current policy and
              ensure it offers the best coverage for you.
            </h4>
          </div>
        </div>
        <Link
          to={
            redirectUrl +
            (redirectUrl.includes("?") ? "&type=review" : "?type=review")
          }
        >
          <button className="bg-white border-[1px] text-[#007aff] border-[#007aff] rounded-[12px] leading-[1.33] px-[15px] py-2 z-2">
            Schedule a Call
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Insurance;
